var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 188,
    viewBox: "0 0 221 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 78,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1627_41367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 47.3048C105.039 45.8015 110.247 45.7643 115.14 47.1978L201.676 72.5467C207.399 74.2232 207.437 82.3173 201.729 84.0469L115.378 110.214C110.337 111.742 104.95 111.702 99.9323 110.101L18.214 84.0202C12.618 82.2343 12.6564 74.3026 18.2695 72.5709L100.166 47.3048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.875 2.53333C112.182 2.53333 100.27 14.4452 100.27 29.1381C100.27 43.831 112.182 55.7428 126.875 55.7428C141.568 55.7428 153.479 43.831 153.479 29.1381C153.479 14.4452 141.568 2.53333 126.875 2.53333ZM135.743 27.3644C131.823 27.3644 128.648 24.1896 128.648 20.2698C128.648 16.3501 131.823 13.1752 135.743 13.1752C139.663 13.1752 142.838 16.3501 142.838 20.2698C142.838 24.1896 139.663 27.3644 135.743 27.3644Z",
    fill: "#4671F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.352 39.4714L83.5727 58.2508C82.9058 58.9177 82.5333 59.8187 82.5333 60.7587V69.932C82.5333 71.8901 84.1225 73.4793 86.0806 73.4793H95.2539C96.194 73.4793 97.0985 73.1069 97.7619 72.44L102.349 67.8533C103.289 66.9133 103.817 65.6363 103.817 64.306C103.817 61.5356 106.063 59.2901 108.833 59.2901C110.163 59.2901 111.44 58.7616 112.38 57.8216L116.541 53.6606C110.156 50.9682 105.044 45.853 102.352 39.4714Z",
    fill: "#A4BCFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1627_41367",
    x1: 206,
    y1: 133,
    x2: 14,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5d4d973a29d38872576c8176350f9c38.svg";
export { ForwardRef as ReactComponent };